/* eslint-disable */
const api = {
  getTableData: '/appprivacy/privacy/sdk/list', // 获取表格数据 http://192.168.3.95:8003/privacy/sdk/list
  delTableData: '/appprivacy/privacy/sdk/delete', //删除表格数据
  editTableData: '/appprivacy/privacy/sdk/update', //修改表格数据
  addTableData: '/appprivacy/privacy/sdk/add', //新添表格数据
};
export default api;
